import type { InviteStats, ReferralsPort } from './ports.ts';
import { postToWorker, type WorkerClient } from './worker.ts';

// A shared page can be resumed after authentication; arbitrary return URLs
// cannot. Keep its query/hash (including ref) without accepting another origin.
export function safeSharedDestination(value: unknown): string {
  if (typeof value !== 'string' || value.length > 2048 || !value.startsWith('/') || value.startsWith('//')) return '/';
  try {
    const decoded = decodeURIComponent(value);
    if ([...decoded].some(char => char === '\\' || char.charCodeAt(0) < 32 || char.charCodeAt(0) === 127)) return '/';
    const url = new URL(value, 'https://guildite.invalid');
    if (url.origin !== 'https://guildite.invalid' || !/^\/(?:p\/[A-Za-z0-9_-]{1,128}|s\/[A-Za-z0-9_.-]{1,128}|g\/[a-z0-9-]{1,100})\/?$/.test(url.pathname)) return '/';
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return '/';
  }
}

// Device capture/clearing and route return remain owned by frontend callers.
// Reuse the SAME random request key only when retrying one link opening.
export function createReferrals({ worker, baseUrl, fetchImpl = fetch }: {
  worker: WorkerClient;
  baseUrl: string;
  fetchImpl?: typeof fetch;
}): ReferralsPort {
  return {
    stats: () => worker.call<InviteStats>('get_my_invite_stats'),
    recordOpen: (handle, requestKey) => postToWorker<{ recorded: true }>(fetchImpl, `${baseUrl}/api/v1/invites`, { handle, requestKey }),
  };
}
